import React, { useState } from 'react';
import { FiCheck } from 'react-icons/fi';
import scoreboard from '../../../assets/scoreboard.png';
import attackmap from '../../../assets/attackmap.png';
// import tabletop from '../../../assets/tabletop.png';

const platformTabs = [
    {
        id: 'ctf',
        title: 'Attack-Defense CTF',
        heading: 'Real-Time Attack-Defense CTF Platform',
        description:
            'Battle-tested platform where participants defend their own infrastructure while attacking others in a live, multi-node environment. Designed to simulate realistic adversarial engagements.',
        features: [
            'Isolated virtual environments per team',
            'Automated service uptime & flag monitoring',
            'Real-time attack visualization & scoring',
            'Secure shell access with granular logging',
        ],
        image: attackmap,
    },
    // {
    //     id: 'tabletop',
    //     title: 'Table Top Exercise',
    //     heading: 'Executive Table Top Exercise Platform',
    //     description:
    //         'Interactive, card-based simulation platform tailored for C-suite, IT managers, and SOC leaders to test decision-making during cyber incidents—without writing a single line of code.',
    //     features: [
    //         'Scenario-driven strategic decision-making',
    //         'Crisis cards with realistic incident triggers',
    //         'Integrated facilitator dashboard',
    //         'Debrief reports for post-exercise insights',
    //     ],
    //     image: tabletop,
    // },
    {
        id: 'jeopardy',
        title: 'Jeopardy CTF',
        heading: 'Jeopardy-Style CTF Platform',
        description:
            'Scalable platform for challenge-based CTF competitions, ideal for universities, community events, and corporate upskilling with intuitive UX and real-time scoring.',
        features: [
            'Multi-category challenges (pwn, web, forensics, etc.)',
            'Auto-deployment of containerized challenges',
            'Live leaderboard with team analytics',
            'User-friendly challenge-solving interface',
        ],
        image: scoreboard,
    },
];

const OurPlatforms = () => {
    const [activeTab, setActiveTab] = useState('ctf');
    const [fadeIn, setFadeIn] = useState(true);

    const handleTabSwitch = (id) => {
        setFadeIn(false);
        setTimeout(() => {
            setActiveTab(id);
            setFadeIn(true);
        }, 100);
    };

    const activeContent = platformTabs.find((tab) => tab.id === activeTab);

    return (
        <section className="bg-[#121212] text-white px-6 md:px-16 py-20">
            <div className="text-center mb-10">
                <h2 className="text-3xl font-bold">
                    Our <span className="text-red-500">Platforms</span>
                </h2>
                <p className="text-gray-400 mt-2">
                    State-of-the-art training environments for cybersecurity professionals
                </p>
            </div>

            {/* Tabs */}
            <div className="flex justify-center gap-4 border-b border-gray-700 mb-10 overflow-x-auto">
                {platformTabs.map((tab) => (
                    <button
                        key={tab.id}
                        onClick={() => handleTabSwitch(tab.id)}
                        className={`px-4 py-2 font-semibold border-b-2 transition ${activeTab === tab.id
                            ? 'border-red-500 text-red-500'
                            : 'border-transparent hover:text-red-500'
                            }`}
                    >
                        {tab.title}
                    </button>
                ))}
            </div>

            {/* Content with fade animation */}
            <div
                className={`transition-all duration-500 ease-in-out transform ${fadeIn ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
                    }`}
            >
                <div className="grid md:grid-cols-2 gap-10 items-start">
                    {/* Left Side */}
                    <div>
                        <h3 className="text-xl font-bold mb-3">{activeContent.heading}</h3>
                        <p className="text-gray-400 mb-6">{activeContent.description}</p>
                        <ul className="space-y-2 text-gray-300 text-sm">
                            {activeContent.features.map((feature, idx) => (
                                <li key={idx} className="flex items-start gap-2">
                                    <FiCheck className="text-red-500 mt-1" />
                                    {feature}
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Right Side - Image */}
                    <div>
                        <img
                            src={activeContent.image}
                            alt={activeContent.title}
                            className="rounded-lg border border-red-500 shadow-md w-full"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default OurPlatforms;
